import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import Input from '../../components/abstractObjects/Input';
import { Grid, Button, Hidden, makeStyles } from '@material-ui/core'
import CustomizedSnackbars from '../../components/abstractObjects/Snackbars'
import * as Constants from '../constants'
import VAR_A from '../../images/VAR-A.png'
//import VAR_F from '../../images/VAR-F.png'
import VAR_R from '../../images/VAR-R.png'
//import VAR_S from '../../images/VAR-S.png'
//import VAR_U from '../../images/VAR-U.png'
import VAR_PO from '../../images/VAR-PO.png'
import VAR_PY from '../../images/VAR-PY.png'
import VAR_C from '../../images/VAR-C.png'
import { BasicLabel } from '../../components/abstractObjects/Label'
import { Translation } from '../translations/getTranslation'

import {
    fetchHistoryVarsList,
    selectHistoryVarById,
    selectHistoryVarIds,
    //sendFinalisedPdf,
    //sendExcel,
    Reload
} from './historyVarsListSlice'

const elementStyle = makeStyles({
    root: {
        width: "100%",
        cursor: "pointer",
        padding: 6.5,
        border: "1.5px solid #ddd",
        borderRadius: 3
    },
    text: {
        color: "#000",
        fontWeight: 400,
        textAlign: "center"
    }
})

let VarExcerpt = ({ varId, setSnackActive, setInfo }) => {
    const dispatch = useDispatch()
    const elementStyles = elementStyle()
    const varx = useSelector((state) => selectHistoryVarById(state, varId))
    if (varId === null) return ""
    
    let color = null
    switch (varx.StatusId) {
        case Constants.VAR_STATUS_CANCELLED:
            color = VAR_C //Constants.VAR_STATUS_COLOR_CANCELLED
            break
        case Constants.VAR_STATUS_APPROVED:
            color = VAR_PO //Constants.VAR_STATUS_COLOR_APPROVED
            break
        case Constants.VAR_STATUS_UPLOADED:
            color = VAR_PY //Constants.VAR_STATUS_COLOR_UPLOADED
            break
        case Constants.VAR_STATUS_SUBMITTED:
            color = VAR_PY //Constants.VAR_STATUS_COLOR_SUBMITTED
            break
        case Constants.VAR_STATUS_REFERBACKSD:
            color = VAR_R //Constants.VAR_STATUS_COLOR_REFERBACKSD
            break
        case Constants.VAR_STATUS_FINALISED:
            color = VAR_A //Constants.VAR_STATUS_COLOR_FINALISED
            break
        default:
            color = VAR_R //Constants.VAR_STATUS_COLOR_UNAPPROVED
    }

    //const SendPdf = async () => {
    //    var res = await dispatch(sendFinalisedPdf(varId))
    //    if (res.payload !== undefined && res.payload.Code === 200)
    //        setInfo({ message: res.payload.Message, type: 'success' })
    //    else {
    //        console.log("Response Error", res.payload)
    //        setInfo({ message: "An error occurred, refresh data and try again", type: 'error' })
    //    }
    //    setSnackActive(true)
    //}

    return (
        <Grid container key={varx.Id} justifyContent="center" style={{ marginBottom: "1rem" }}>
            <Grid item xs={2}>
                <Button style={{ minWidth: 40, width: "calc(5px + 50%)" }} title={Translation.t("DOWNLOAD_PDF")} size="large" variant="outlined" onClick={() => window.open(`/VarTransactions/DownloadFinalisedPdf?VarTransactionId=${varx.Id}`)}>
                    <span className="fas fa-file-alt" />
                </Button>
            </Grid>
            <Grid item className={elementStyles.root} xs={10}>
                <Link to={`/history/${varx.Id}`} style={{ width: "100%", textDecoration: "none" }}>
                    <Grid container>
                        <Grid container item xs={2} sm={1} justifyContent="center" alignItems="center">
                            <img style={{ marginLeft: 12, width: 55, height: 50 }} className="varStatusCircle" src={color} alt="var" />
                        </Grid>
                        <Grid item xs={10} sm={6} className={elementStyles.text}>
                            <h4 style={{ marginBottom: 0 }}>{varx.ReportNo}</h4>
                            <Hidden smUp>AWB n. {varx.Awbno}<br /></Hidden>
                            PO n. {varx.Pono}
                        </Grid>
                        <Hidden xsDown>
                            <Grid item sm={5} className={elementStyles.text}>
                                <h4>AWB n. {varx.Awbno}</h4>
                                <div style={{ textAlign: 'center', fontWeight: '500' }}>ETA {varx.EstimatedDateOfArrival.substring(0, 10).split("-").reverse().join("/")}</div>
                            </Grid>
                        </Hidden>
                    </Grid>
                </Link>
            </Grid>
        </Grid>
    )
}


export const HistoryVarsList = () => {
    const dispatch = useDispatch()
    const orderedVarIds = useSelector(selectHistoryVarIds)

    const varStatus = useSelector((state) => state.historyVars.status)
    const error = useSelector((state) => state.historyVars.error)

    const [snackObj, setSnackObj] = useState({ title: null, message: null, type: 'info' })
    const [snackActive, setSnackActive] = useState(false)
    const [months, setMonths] = useState(1)

    const OnMonthsChanged = (e) => {
        setMonths(e.target.value)
        dispatch(Reload())
    }

    // #region Dismiss
    //const SendExcel = async () => {
    //    var res = await dispatch(sendExcel({ takeMonths: months, type: "" }))
    //    if (res.payload !== undefined && res.payload.Code === 200)
    //        setSnackObj({ message: res.payload.Message, type: 'success' })
    //    else {
    //        console.log("Response Error", res.payload)
    //        setSnackObj({ message: "An error occurred, refresh data and try again", type: 'error' })
    //    }
    //    setSnackActive(true)
    //}
    //const SendExcelPivot = async () => {
    //    var res = await dispatch(sendExcel({ takeMonths: months, type: "pivot" }))
    //    if (res.payload !== undefined && res.payload.Code === 200)
    //        setSnackObj({ message: res.payload.Message, type: 'success' })
    //    else {
    //        console.log("Response Error", res.payload)
    //        setSnackObj({ message: "An error occurred, refresh data and try again", type: 'error' })
    //    }
    //    setSnackActive(true)
    //}
    // #endregion

    useEffect(() => {
        if (varStatus === 'idle')
            dispatch(fetchHistoryVarsList(months))
    }, [varStatus, dispatch, months])

    let content
    if (varStatus === 'loading') {
        content = <div className="loader"></div>
    } else if (varStatus === 'succeeded') {
        content = orderedVarIds.map((varId) => (
            <VarExcerpt key={varId} varId={varId} setSnackActive={setSnackActive} setInfo={setSnackObj} />
        ))
    } else if (varStatus === 'error') {
        content = <div>{error}</div>
    }

    var optionsMonths = [{ Name: "ALL", Id: 99 }, { Name: "1_MONTH", Id: 1 }, { Name: "3_MONTH", Id: 3 }, { Name: "6_MONTH", Id: 6 }]
    return (
        <section className="var-list">
            <br />
            <Grid container align="center">
                <Grid item xs={12} md={6}><h2><BasicLabel text="HISTORIC_VARS" /></h2></Grid>
                <Grid item xs={8} md={4}><Input style={{maxWidth: 260}} type="select" size="small" variant="outlined" value={months} selectOptions={optionsMonths} onChange={OnMonthsChanged} /></Grid>
                <Grid item xs={4} md={2}><Button variant="outlined" title="Refresh Data" onClick={() => dispatch(Reload())}><i className="fas fa-sync-alt" /></Button></Grid>
                <Grid item xs={6} md={6} style={{ marginTop: "8px" }}><Button variant="outlined" title="Download Detailed Excel" onClick={() => window.open(`/VarTransactions/DownloadExcel?takeMonths=${months}&type=pivot`)}><i className="fas fa-file-excel" />&nbsp;<BasicLabel text="DETAILED_EXCEL" /></Button></Grid>
                <Grid item xs={6} md={6} style={{ marginTop: "8px" }}><Button variant="outlined" title="Download Excel" onClick={() => window.open(`/VarTransactions/DownloadExcel?takeMonths=${months}`)}><i className="fas fa-file-excel" />&nbsp;<BasicLabel text="EXCEL" /></Button></Grid>
            </Grid>
            <br /><br />
            {content}
            <CustomizedSnackbars snackActive={snackActive} setSnackActive={setSnackActive} info={snackObj} setInfo={setSnackObj} />
        </section>
    )
}